import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ManagementReservationDetail } from "@/components/features/management";

import { useConfirmParams } from "./hooks";

export const ManagementReservationDetailPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID, reservationID } = result;

	return (
		<PageMeta
			title="予約の管理"
			url={generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.DETAIL, { hotelID, reservationID })}
		>
			<ManagementReservationDetail hotelID={hotelID} reservationID={reservationID} />
		</PageMeta>
	);
};
